import Vue from 'vue'
// basicos
import Card from './basicos/Card'
import VerMais from './basicos/VerMais'
import Child from './basicos/Child'
import Button from './basicos/Button'
import BtnVoltar from './basicos/BtnVoltar'
import Checkbox from './basicos/Checkbox'
import pagination from './basicos/Pagination'
import bTable from './basicos/Table'
import mInput from './basicos/mInput'
import helpPopper from './basicos/helpPopper'
// especiais
import SubMenuLink from './especificos/SubMenuLink'
import inputCadastroBusca from './especiais/inputCadastroBusca'
// especificos do projeto psiqueasy
import ModalExcluir from './especificos/ModalExcluir'
import OpenModalConfigImprimir from './especificos/OpenModalConfigImprimir'
import AlertConectPagSeguro from './especificos/AlertConectPagSeguro'

import { HasError, AlertError, AlertErrors, AlertSuccess } from 'vform'
// Components that are registered globaly.
[
  pagination,
  VerMais,
  helpPopper,
  bTable,
  Card,
  mInput,
  Child,
  Button,
  Checkbox,
  HasError,
  AlertError,
  AlertErrors,
  AlertSuccess,
  SubMenuLink,
  BtnVoltar,
  ModalExcluir,
  inputCadastroBusca,
  OpenModalConfigImprimir,
  AlertConectPagSeguro,
  // inputCadastroBusca
].forEach(Component => {
  Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js